import { atom } from 'jotai';

import { SwingAnalysis, SwingResponse, VideoPayload } from '@data';

export const activeAnalysisAtom = atom<SwingAnalysis>();

export const selectedActiveAnalysisAtom = atom((get) => {
    const analysis = get(activeAnalysisAtom);
    return analysis?.fullAnalysis ?? analysis?.quickAnalysis;
});

export const hasFullAnalysisAtom = atom((get) => {
    const analysis = get(activeAnalysisAtom);
    return !!analysis?.fullAnalysis;
});

export const activeVideoAtom = atom<VideoPayload[]>([]);

export const activeVideosMapAtom = atom((get) => {
    const activeVideos = get(activeVideoAtom);
    return Object.fromEntries(activeVideos.map((video) => [video.cameraId, video] as const));
});

export const activeVideosViewMapAtom = atom((get) => {
    const activeVideos = get(activeVideoAtom);
    return Object.fromEntries(activeVideos.map((video) => [video.view, video] as const));
});

export const activeSwingAtom = atom<SwingResponse>();

export const comparisonAnalysisAtom = atom<SwingAnalysis>();

export const comparisonVideoAtom = atom<VideoPayload[]>([]);

export const comparisonSwingAtom = atom<SwingResponse | undefined>();
